import {Component, Inject, OnInit,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {filter, tap} from 'rxjs/operators';
import {InstructorPlanDetails, instructorPlans, instructorPlansFrequency} from '../instructor-plans';
import {createDefaultDialogConfig} from '../../../common/dialog-utils';
import {AppState} from '../../../store';
import {select, Store} from '@ngrx/store';
import {selectTenantInfo} from '../../../store/selectors';
import {MessagesService} from '../../../shared/services/messages.service';
import {MatButtonModule} from '@angular/material/button';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {NgClass, NgIf, UpperCasePipe} from '@angular/common';


@Component({
    selector: 'change-instructor-plan-dialog',
    templateUrl: "change-instructor-plan-dialog.component.html",
    styleUrls: ["change-instructor-plan-dialog.component.scss",
        "../common-instructor-plan-dialog.component.scss"],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, NgIf, MatIconModule, MatRadioModule, NgClass, MatButtonModule, UpperCasePipe]
})
export class ChangeInstructorPlanDialogComponent implements OnInit {

  form = this.fb.group({
    instructorPricingPlan: ["pro", Validators.required],
    instructorPlanFrequency: ["yearly"]
  });

  currentInstructorPlanId:string;
  currentInstructorPlanFrequency :string;

  currentInstructorPlan: InstructorPlanDetails;
  currentInstructorFrequencyDescription: string;

  activateTrial:boolean = false;


  newInstructorPlan:string;
  newInstructorPlanFrequency:string;

  growth = instructorPlans["growth"];
  basic = instructorPlans["basic"];
  pro = instructorPlans["pro"];
  enterprise = instructorPlans["enterprise"];

  classBoldMonthly: string;
  classBoldYearly: string;
  check:boolean = true;

  constructor(
    private dialogRef: MatDialogRef<ChangeInstructorPlanDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data,
    private store: Store<AppState>,
    private messages:MessagesService) {

    this.newInstructorPlan = data.newInstructorPlan;
    this.newInstructorPlanFrequency = data.newInstructorPlanFrequency;
    this.activateTrial = data.activateTrial;

  }

  ngOnInit() {

    this.store
      .pipe(
        select(selectTenantInfo),
        tap(tenant => {

          this.currentInstructorPlanId = tenant.instructorPricingPlan;
          this.currentInstructorPlanFrequency = tenant.instructorPlanFrequency;

          this.currentInstructorPlan = instructorPlans[tenant.instructorPricingPlan];
          this.currentInstructorFrequencyDescription = instructorPlansFrequency[tenant.instructorPlanFrequency];

          if (tenant.instructorPricingPlan =='growth') {
            this.currentInstructorFrequencyDescription = '';
          }

          this.form.patchValue({
            instructorPricingPlan: this.newInstructorPlan ?? (tenant.instructorPricingPlan != "growth" ? tenant.instructorPricingPlan : "pro" ),
            instructorPlanFrequency: this.newInstructorPlanFrequency ?? (tenant.instructorPlanFrequency ?? 'yearly')
          });

        })
      )
      .subscribe();

     this.radioButtonClass()
  }

  radioButtonClass() {
    if (this.check) {
      this.classBoldYearly = 'boldRadioButton';
      this.classBoldMonthly = 'unBoldRadioButton';
      this.check = false;
    }
    else {
      this.classBoldYearly = 'unBoldRadioButton';
      this.classBoldMonthly = 'boldRadioButton';
      this.check = true;
    }

  }
  close() {
    this.dialogRef.close();
  }

  get isFreePlanSelected() {
    return this.form.controls["instructorPricingPlan"]?.value == 'growth';
  }

  pricingDetails(instructorPricingPlan:string) {

    const selectedPlanFrequency = this.form.controls['instructorPlanFrequency']?.value;

    const yearlyPlanPrice = instructorPlans[instructorPricingPlan]?.pricingDetails?.yearly
      .split(/ (.*)/)[1];

    return {monthly:instructorPlans[instructorPricingPlan]?.pricingDetails[selectedPlanFrequency],
            yearly: yearlyPlanPrice?.slice(1, yearlyPlanPrice?.length-1)};
  }

  get selectedPlan() {
    return this.form.controls["instructorPricingPlan"]?.value;
  }

  get selectedFrequency() {
    return this.form.controls['instructorPlanFrequency']?.value;
  }

  changePlan() {

    const selectedInstructorPlanId = this.selectedPlan,
      selectedPlanFrequency = this.selectedFrequency;

    this.dialogRef.close({
      selectedInstructorPlanId,
      selectedPlanFrequency
    });

  }

  isCurrentPlanSelected() {

    if (this.selectedPlan == 'growth' && this.currentInstructorPlanId == 'growth') {
      return true;
    }

    return this.currentInstructorPlanId == this.selectedPlan && this.currentInstructorPlanFrequency == this.selectedFrequency;
  }


}


export function createInstructorPlanDialog(
  dialog: MatDialog,
  newInstructorPlan?:string,
  newInstructorPlanFrequency?:string,
  activateTrial?:boolean) {

  const dialogConfig = createDefaultDialogConfig();

  dialogConfig.minWidth = '390px';

  dialogConfig.data = {
    newInstructorPlan,
    newInstructorPlanFrequency,
    activateTrial

  };


  const dialogRef = dialog.open(ChangeInstructorPlanDialogComponent, dialogConfig);

  return dialogRef.afterClosed()
    .pipe(
      filter(val => !!val)
    );
}


